export const carsConfig = {
    basePath: '/assets/cars', // без кінцевого слеша // базовий шлях до всіх фото
    cars: [
        {
            id: '1',
            name: 'Mercedes G (1)',
            basePrice: 95000, // базова ціна авто
            images: {
                background: '1 - Background.png',
                backgroundShadow: '1 - Background_Shadow.png',
                main: '1 - Main.png',
                coverHeadlights: '1 - Cover_Headlights.png',
                coverTurnlights: '1 - Cover_Turnlights.png',
            },
            components: {
                bodies: [
                    { id: 'biel', name: 'Biel polarna', file: '1 - Body_Biel_polarna.png', price: 0 },
                    { id: 'blekit', name: 'Błękit brylantu', file: '1 - Body_Blekit_brylantu.png', price: 800, selected: true },
                    { id: 'czern', name: 'Czern magnetytu', file: '1 - Body_Czern_magnetytu.png', price: 1000 },
                    { id: 'g_blekit', name: 'G manufaktur błękit oceanu metalik', file: '1 - Body_G_manufaktur_blekit_oceanu_metalik.png', price: 1200 },
                    { id: 'g_zolty', name: 'G manufaktur słoneczny żolty', file: '1 - Body_G_manufaktur_sloneczny_zolty.png', price: 1100 },
                    { id: 'srebrny', name: 'Srebrny iryd', file: '1 - Body_Srebrny_iryd.png', price: 900 },
                    { id: 'szarosc', name: 'Szarosc selenitu', file: '1 - Body_Szarosc_selenitu.png', price: 950 },
                ],
                tents: [
                    { id: 't1', name: 'Tent 1', file: '1 - Tent_1.png', price: 300 },
                    { id: 't2', name: 'Tent 2', file: '1 - Tent_2.png', price: 350 },
                    { id: 't3', name: 'Tent 3', file: '1 - Tent_3.png', price: 400 },
                ],
                wheels: {
                    '1': {
                        name: 'Standard wheels',
                        variations: {
                            '1': { file: '1 - Wheels_1_1.png', price: 0 },
                            '2': { file: '1 - Wheels_1_2.png', price: 250 },
                            '3': { file: '1 - Wheels_1_3.png', price: 400 },
                        },
                    },
                    '2': {
                        name: 'Sport wheels',
                        variations: {
                            '1': { file: '1 - Wheels_2_1.png', price: 600 },
                            '2': { file: '1 - Wheels_2_2.png', price: 750 },
                            '3': { file: '1 - Wheels_2_3.png', price: 900 },
                        },
                    },
                },
            },
        },
    ],
};
